import React from 'react';
import { ApiAdminInterface } from '../components/ApiAdminInterface';

export const AdminPage: React.FC = () => {
    return <ApiAdminInterface />;
};